import { render } from "./AlarmThresholdChips.vue?vue&type=template&id=010e2124"
import script from "./AlarmThresholdChips.vue?vue&type=script&lang=js"
export * from "./AlarmThresholdChips.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__